// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectManagementUI_projectTitle__BPhSS {
  background-color: #fff !important;
}
.ProjectManagementUI_projectTitle__BPhSS:hover {
  background-color: #cfcfcf !important;
}
.ProjectManagementUI_projectTitleOpenInquiry__r3xVC {
  background-color: #FFCDD2 !important;
}
.ProjectManagementUI_projectTitleOpenInquiry__r3xVC:hover {
  background-color: #EF9A9A !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/project_management/layout/ProjectManagementUI.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".projectTitle {\n  background-color: #fff !important;\n}\n.projectTitle:hover {\n  background-color: #cfcfcf !important;\n}\n.projectTitleOpenInquiry {\n  background-color: #FFCDD2 !important;\n}\n.projectTitleOpenInquiry:hover {\n  background-color: #EF9A9A !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"projectTitle": `ProjectManagementUI_projectTitle__BPhSS`,
	"projectTitleOpenInquiry": `ProjectManagementUI_projectTitleOpenInquiry__r3xVC`
};
export default ___CSS_LOADER_EXPORT___;
